class BinaFilterApplyCountdown {
  constructor({
    seconds = 5,
    onTick,
    onComplete,
    setIntervalFn = (callback, delay) => globalThis.setInterval(callback, delay),
    clearIntervalFn = (timer) => globalThis.clearInterval(timer)
  }) {
    this.seconds = seconds;
    this.onTick = onTick;
    this.onComplete = onComplete;
    this.setIntervalFn = setIntervalFn;
    this.clearIntervalFn = clearIntervalFn;
    this.timer = null;
    this.remaining = 0;
  }

  reset() {
    this.cancel();
    this.remaining = this.seconds;
    this.onTick(this.remaining);
    this.timer = this.setIntervalFn(() => {
      this.remaining -= 1;
      if (this.remaining <= 0) {
        this.cancel();
        this.onComplete();
      } else {
        this.onTick(this.remaining);
      }
    }, 1000);
  }

  cancel() {
    if (this.timer !== null) this.clearIntervalFn(this.timer);
    this.timer = null;
  }

  complete() {
    if (this.timer === null) return;
    this.cancel();
    this.onComplete();
  }
}

globalThis.BinaFilterApplyCountdown = BinaFilterApplyCountdown;
